export default function WhyUsersSearch() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-4">
            Why It Matters
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Why Thousands Of Users Search For{" "}
            <span className="text-primary-500">Hipobuy Spreadsheet</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            See how organized spreadsheet resources compare to traditional product browsing methods
          </p>
        </div>

        {/* Comparison Table */}
        <div className="max-w-4xl mx-auto overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr>
                <th className="text-left py-4 px-5 text-sm font-semibold text-foreground-700 bg-background-200/50 rounded-tl-xl">Feature</th>
                <th className="text-center py-4 px-5 text-sm font-semibold text-foreground-500 bg-background-200/30">
                  Traditional Product Search
                </th>
                <th className="text-center py-4 px-5 text-sm font-semibold text-primary-600 bg-primary-50/80 rounded-tr-xl">
                  Hipobuy Spreadsheet
                </th>
              </tr>
            </thead>
            <tbody>
              {[
                { feature: "Research Speed", trad: "Scattered across pages", spread: "Everything in one place", icon: "ri-timer-flash-line" },
                { feature: "Product Organization", trad: "Unstructured browsing", spread: "Organized by category", icon: "ri-stack-line" },
                { feature: "Category Filtering", trad: "Limited filter options", spread: "Clear category breakdowns", icon: "ri-filter-3-line" },
                { feature: "Decision Making", trad: "Overwhelming choices", spread: "Side-by-side comparison", icon: "ri-scales-3-line" },
                { feature: "Beginner Friendly", trad: "Steep learning curve", spread: "Intuitive navigation", icon: "ri-user-smile-line" },
              ].map((row, i) => (
                <tr key={row.feature} className={`border-b border-background-200/50 ${i % 2 === 0 ? "bg-background-50/50" : "bg-transparent"}`}>
                  <td className="py-4 px-5">
                    <div className="flex items-center gap-2.5">
                      <div className="w-7 h-7 rounded-md bg-secondary-100 flex items-center justify-center flex-shrink-0">
                        <i className={`${row.icon} text-secondary-600 text-xs`}></i>
                      </div>
                      <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{row.feature}</span>
                    </div>
                  </td>
                  <td className="py-4 px-5 text-center">
                    <span className="text-sm text-foreground-500">{row.trad}</span>
                  </td>
                  <td className="py-4 px-5 text-center bg-primary-50/30">
                    <span className="text-sm font-medium text-primary-600">{row.spread}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}